<template>
    <ul id="list-tasks">
      <li>

        <!--pc view-->
        <div id='oblea' v-show="item.tipoOblea == 1 && !mobileView">
          <div id='s1'>
            <img :src="imagenProducto" style="width: 90%; height: 90%; object-fit: contain" /> 
          </div> 

          <div id='s2' style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; margin-left: 10px">
            <div>
              <span id='titulo'>{{nombre}}</span>
            </div>
            <div>
              <span class='label'>Precio:</span> 
              <span class='value'>${{item.Precio | formatMoney}}</span>
            </div>
          </div> 

          <div id='s22'>
            <div id='cc'>
              <span id='cantidad'>Cantidad: {{item.Cantidad}}</span> 
            </div> 
          </div> 
          
          <div id='s3' style="width: 35%;display: flex; flex-direction: row; justify-content: flex-end; align-items: center; margin-right: 5px">
            <div>
              <span class='label'>Subtotal:</span>
              <span class='value' style="width: 110px; display: flex; flex-direction: row; justify-content: flex-end" >${{(item.Precio)*item.Cantidad | formatMoney}}</span>
            </div>
          </div> 

        </div>

        <div id='oblea-desc' v-show="item.tipoOblea == 2 && !mobileView" >
          <div id='s1'>
          </div> 
          <div id='s2' style="width: 55%">
            <span id='titulo'>{{item.ProductoNombre}}</span>
          </div> 
          <div class="fh lc" style="width: 35%; height: 100%; padding-left: 10px; display: flex; flex-direction: row; justify-content: flex-end">
              <div class="fh lc" style="font-size: 12px; color: #656E76; margin-left: 5px; margin-right: 5px">
                   ${{item.Precio | formatMoney}}
              </div>
          </div> 
          <!-- <div id='s3'>
          </div> 
          <div id='s4'>
          </div>  -->
        </div>


        <!--mobile view-->
        <div v-show="item.tipoOblea == 1  && mobileView" class="fv ct" style="width:90vw; border-style: solid;border-width: 1px; border-color: #dddddd; border-radius: 10px;  box-shadow: 2px 2px 4px #dddddd; -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow:2px 2px 4px #dddddd;  margin-bottom: 20px">
            <div class="fh cc" style="width:100%; height:140px;">
                <div class="fv cc" style="width:40%; height:100%;" >
                    <img style="width: 80%" :src="imagenProducto"/>
                </div>
                <div class="fv cc" style="width:60%; height:100%;" >
                    <div class="fh lc" style="font-size: 14px; font-weight: 800; color: #5C666F"> {{nombre}} </div>
                    <div class="fh lc" style="font-size: 12px; font-weight: 500; margin-top: 15px; color: #5C666F"> Precio: ${{item.Precio | formatMoney}}</div>
                    <div class="fh lc" style="font-size: 12px; font-weight: 500; margin-top: 5px; color: #5C666F"> Cantidad: {{item.Cantidad}}</div>
                    <div class="fh lc" style="font-size: 13px; font-weight: 500; margin-top: 10px; color: #5C666F"> Subtotal: ${{(item.Precio)*item.Cantidad | formatMoney}}</div>
                </div>
            </div>
        </div>

        <div class="fh lc" v-show="item.tipoOblea == 2 && mobileView" style="width: 90vw; height:30px; margin-top: 10px; margin-bottom: 5px; background-color: #ffffaa; border-style: solid; border-width: 1px; border-color:#dddddd; border-radius: 10px; box-shadow: 1px 1px 3px #dddddd;">
          <div class="fh cc" style="width: 50%;">
            <span id='titulo'>{{item.ProductoNombre}}</span>
          </div> 
          <div class="fh cc" style="width: 50%;">
            <span class='label-desc'>Descuento:</span> 
            <span class='value'> ${{item.Precio | formatMoney}}</span>
          </div> 
        </div>

      </li>
    </ul>
</template>
  



   
  <script>
  import axios from 'axios'

    export default {
      name: 'item-pedidoCms',
      props: ['item'],

      data()  {
        return {
          mobileView:false  
        }
      },

      watch: {
        item: {
          immediate: true,
          handler  () {
          }
        }
      },


      computed: {
        nombre(){
          if (this.item.ProductoNombre.length > 1)
          {
            return this.item.ProductoNombre
          }
          else
          {
            return this.item.PromocionNombre
          }
        },

        imagenProducto() {
          if (this.item.UrlImagen != null) {
            return this.item.UrlImagen
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        }, 

      },



      methods: {
        
        onResize() {
            if (window.innerWidth > 600) 
            {
            this.mobileView=false;
            }
            else 
            {
            this.mobileView=true;
            }
        },


      },

      mounted () {
    this.onResize()
   },

   created() {
     window.addEventListener('resize', this.onResize)
   },

   beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
   }

    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 5px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
#oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}


#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 27%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 38%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-end;  
}

#s4{
  width: 8%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}




.label-desc{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 70px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}
  
#s1{
  width: 12%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 38%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}


#s3{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s4{
  width: 6%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}
 

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#cantidad{
  font-size: 12px;
  color: #656E76;
  margin-top: 3px;
  margin-bottom: 3px;
}

 
  
   </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/itemPedidoCms.vue